angular.module("labApp").factory("LabFilterOperatorsFactory", ["$resource", function ($resource) {
    return $resource('/api/v1.0/filter-thresholds/operators/');
}]);
